<template>
	<!-- 外层ul控制卡片范围 -->
	<div>
		<div class="point" ref="point" :style="`left:${moveLeft}px;top:${moveTop}px;`" @touchstart="dragStart" @touchend="dragEnd" @touchmove.prevent="dragMove">
			<slot></slot>
		</div>
	</div>
</template>

<script>
import { Toast } from 'vant';
export default {
	name: 'FloatBtn',
	props: {},
	data() {
		return {
			border_distance: 0, //可拖拽元素距离屏幕边界最小距离
			divWidth: 150 / 2, //可拖拽元素宽度
			divHeight: 277 / 2, //可拖拽元素高度
			moveLeft: document.documentElement.clientWidth - 150 / 2, //可拖拽元素距离屏幕左边界
			moveTop: document.documentElement.clientHeight - 277 / 2, //可拖拽元素距离屏幕上边界
			clientWidth: document.documentElement.clientWidth, //屏幕宽度
			clientHeight: document.documentElement.clientHeight //屏幕高度
		};
	},
	mounted() {
		// console.log(this.clientWidth, this.clientHeight);
	},
	methods: {
		dragStart(e) {
			this.$refs.point.style.transition = 'none';
		},
		dragEnd(e) {
			this.$refs.point.style.transition = 'all 0.3s';
			// if (this.moveLeft > this.clientWidth / 2) {
			// 	//若移动位于屏幕的左边或右边，则自动贴合左边或右边（此根据业务具体需求表现而定）
			// 	this.moveLeft = this.clientWidth - this.divWidth - this.border_distance;
			// } else {
			// 	this.moveLeft = this.border_distance;
			// }
			this.moveLeft = this.clientWidth - this.divWidth - this.border_distance; //右侧自动贴边

			if (this.moveTop < 0) {
				this.moveTop = 10;
			} else if (this.moveTop + 277 / 2 > this.clientHeight) {
				this.moveTop = this.clientHeight - 277 / 2;
			}
		},
		dragMove(e) {
			if (e.touches.length) {
				let touch = e.touches[0];
				this.moveLeft = touch.clientX - this.divWidth / 2; //因拖动的中间点为Dom节点的中心点，所以left需减去Dom节点一半的宽度
				this.moveTop = touch.clientY - this.divHeight / 2; //top原理同上
			}
		}
	}
};
</script>

<style lang="less" scoped>
.point {
	position: fixed;
	z-index: 999;
	text-align: right;
	width: auto;
	height: auto;
}
</style>
